// Product.jsx
import React, { useState, useEffect, useContext } from 'react';
import './Product.css';
import { useProduct } from '../../Context/ProductContext';
import { useUser } from '../../Context/UserContext';
import { useNav } from '../../Context/NavContext';
import star from '../../assets/frontend_assets/star_icon.png';
import star_dull from '../../assets/frontend_assets/star_dull_icon.png';
import { useNavigate } from 'react-router-dom';
import { UrlContext } from '../../Context/UrlContext';

function Product() {

     const { apiBaseUrl } = useContext(UrlContext);

  const { productDetails } = useProduct();
  const { user } = useUser();
  const { setActiveItem } = useNav();
  const [count, setCount] = useState(1);
  const [selectedSize, setSelectedSize] = useState(null);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [availableSizes, setAvailableSizes] = useState([]);
  const navigate = useNavigate();

  console.log(availableSizes)

  useEffect(() => {
    const fetchSizes = async () => {
      if (!productDetails.id) return;

      try {
        const response = await fetch(`${apiBaseUrl}/products/${productDetails.id}/sizes`);
        if (!response.ok) throw new Error('Failed to fetch sizes');
        const data = await response.json();
        setAvailableSizes(data);
        setSelectedSize(null);
      } catch (error) {
        console.error(error);
        setMessage({ type: 'error', text: 'Failed to load sizes' });
      }
    };
    fetchSizes();
  }, [productDetails.id]);

  const handleSizeSelect = (size) => {
    setSelectedSize(size);
    setMessage({ type: '', text: '' });
  };

 

  const handleAddToCart = async () => {
    if (!user?.id) {
      setActiveItem('ACCESS');
      navigate('/');
      return;
    }

    if (!selectedSize) {
      setMessage({ type: 'error', text: 'Please select a size' });
      return;
    }

    try {
      const res = await fetch(`${apiBaseUrl}/cart/add`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: user.id,
          product_id: productDetails.id,
          product_size_id: selectedSize.id,
          price: productDetails.price,
          count
        })
      });

      const data = await res.json();
      if (res.ok) {
        setMessage({ type: 'success', text: 'Added to cart successfully!' });
        setTimeout(() => setActiveItem('COLLECTION'), 2000);
      } else {
        setMessage({ type: 'error', text: data.error || 'Failed to add to cart' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Server error. Please try again.' });
    }
  };

  console.log(productDetails)

  return (
    <div className="product_container">
      <div className="product_blog">
        <div className="product_image">
          <img src={`data:image/jpeg;base64,${productDetails.image}`} alt="product" />
        </div>
        <div className="product_details">
          <h3>{productDetails.name}</h3>
          <div className="p_rating">
            <div className="stars">
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star} alt="" />
              <img src={star_dull} alt="" />
            </div>
            <p>({productDetails.sales_count})</p>
          </div>
          <p className="p_price">Rs.{productDetails.price}</p>
          <div className="pluscounter2">
            <button onClick={() => setCount(count > 1 ? count - 1 : 1)}>-</button>
            <input type="text" className='input2' value={count} readOnly />
            <button onClick={() => setCount(count < productDetails.stockCount ? count + 1 : count)}>+</button>
          </div>
          <p className="p_des">{productDetails.description}</p>
          <div className="p_size">
            <label>Select Size:</label>
            <div className="sizes2">
              {availableSizes.map((size) => (
                <button
                  key={size.id}
                  className={selectedSize?.id === size.id ? 'selected' : ''}
                  onClick={() => handleSizeSelect(size)}
                >
                  {size.size}
                </button>
              ))}
            </div>
          </div>
          {message.text && <div className={`message ${message.type}`}>{message.text}</div>}
          <button onClick={handleAddToCart}>Add to Cart</button>
        </div>
      </div>
    </div>
  );
}

export default Product;
